import axios from 'axios';
import {Message} from 'iview'
import store from '../store/index'

let baseURLStr = window.g.ApiUrl;
axios.defaults.baseURL = baseURLStr;

//请求拦截器
axios.interceptors.request.use(config => {
    let token = localStorage.getItem('token');
    if(token) {
        config['headers']['common']['Authorization'] = token;
    }
    return config
});
//相应拦截器
axios.interceptors.response.use(response => {
    if (response.data.code == 400) {
        localStorage.clear();
        Message.info(response.data.message);
        store.dispatch('setUserInfo', {});
        console.clear();
    }else {
        return response.data;
    }
});

export default axios






// WEBPACK FOOTER //
// ./src/api/index.js